import { render, staticRenderFns } from "./company-info-linkman.vue?vue&type=template&id=00834897&scoped=true&"
import script from "./company-info-linkman.vue?vue&type=script&lang=js&"
export * from "./company-info-linkman.vue?vue&type=script&lang=js&"
import style0 from "./company-info-linkman.vue?vue&type=style&index=0&id=00834897&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00834897",
  null
  
)

export default component.exports